var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1190,
    height: 1432,
    viewBox: "55 80 1190 1432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Legs / 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoes_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M662.095 1369.67L662.662 1320.57L599.656 1288.67L590.512 1429.06H808.804C771.661 1387.01 662.095 1369.67 662.095 1369.67ZM382.473 1371.59L383.042 1316.43L341.965 1350.04L308.911 1368.54L298.001 1429.06H447.407C428.622 1377.64 382.473 1371.59 382.473 1371.59Z",
    fill: "#0D0B6D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Leg skin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.042 1316.43L320.036 1297.4L308.909 1368.53L382.473 1371.59L383.042 1316.43ZM662.662 1320.57L599.656 1301.54L594.576 1366.62L662.096 1369.67L662.662 1320.57Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pants"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pants_2",
    d: "M671.692 1304.46L670.239 1350.04H587.13L588.587 1304.33C579.276 1300.58 572.624 1291.55 572.397 1280.88L559.019 598.24L414.47 1287.43C412.433 1297.12 405.278 1304.65 396.191 1307.43L390.757 1350.04H303.616L311.115 1302.99C303.859 1297.34 299.654 1288.04 301.1 1278.11L434.18 364.682L554.442 364.682L554.435 364.333H700.095L691.364 1279.61C691.243 1291.64 682.911 1301.71 671.692 1304.46Z",
    fill: "#2F2F3D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    opacity: 0.197824,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.28 609.057L583.784 495.441L564.596 839.897L558.28 609.057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pants line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pants line_2",
    d: "M465.295 365.543L479.253 367.832L327.031 1298.68L313.032 1296.33L465.295 365.543Z",
    fill: "#EFEFEF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.9568a770.svg";
export { ForwardRef as ReactComponent };